var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g = Object.create((typeof Iterator === "function" ? Iterator : Object).prototype);
    return g.next = verb(0), g["throw"] = verb(1), g["return"] = verb(2), typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
import { getHeaders } from "../utils/apiUtils";
import { escapeCql } from "./agencyPrefixesService";
import { collectionsIssnByIssn } from "../types/apiPaths";
import { normalizeIssn } from "../utils/collectionDisplayUtils";
export var fetchCollections = function (kyInstance, filters) { return __awaiter(void 0, void 0, void 0, function () {
    var name, type, publisher, issn, excludeCeased, offset, limit, queryParts, searchParams, baseQuery, response;
    return __generator(this, function (_a) {
        switch (_a.label) {
            case 0:
                name = filters.name, type = filters.type, publisher = filters.publisher, issn = filters.issn, excludeCeased = filters.excludeCeased, offset = filters.offset, limit = filters.limit;
                queryParts = [];
                if (name)
                    queryParts.push("mainName==\"*".concat(escapeCql(name), "*\""));
                if (type)
                    queryParts.push("type==\"".concat(type, "\""));
                if (publisher)
                    queryParts.push("publisher.sourceId==\"".concat(publisher, "\""));
                if (issn === null || issn === void 0 ? void 0 : issn.trim())
                    queryParts.push("issn==\"".concat(escapeCql(normalizeIssn(issn)), "\""));
                if (excludeCeased)
                    queryParts.push("status<>\"CEASED\"");
                searchParams = new URLSearchParams();
                baseQuery = queryParts.length > 0 ? queryParts.join(" and ") : "cql.allRecords=1";
                searchParams.set("query", "".concat(baseQuery, " sortBy mainName"));
                searchParams.set("offset", String(offset));
                searchParams.set("limit", String(limit));
                return [4 /*yield*/, kyInstance.get("collections", {
                        searchParams: searchParams,
                        headers: getHeaders(),
                    })];
            case 1:
                response = _a.sent();
                if (!response.ok) {
                    throw new Error("Fetch error: ".concat(response.status, " ").concat(response.statusText));
                }
                return [2 /*return*/, response.json()];
        }
    });
}); };
export var updateCollection = function (ky, id, updates) { return __awaiter(void 0, void 0, void 0, function () {
    var error_1;
    return __generator(this, function (_a) {
        switch (_a.label) {
            case 0:
                _a.trys.push([0, 2, , 3]);
                return [4 /*yield*/, ky.put("collections/".concat(id), {
                        json: updates,
                        headers: getHeaders(),
                    })];
            case 1:
                _a.sent();
                console.log("Collection updated successfully");
                return [3 /*break*/, 3];
            case 2:
                error_1 = _a.sent();
                console.error("Error updating collection:", error_1);
                throw error_1;
            case 3: return [2 /*return*/];
        }
    });
}); };
export var createCollection = function (ky, newCollection) { return __awaiter(void 0, void 0, void 0, function () {
    var response, data, error_2;
    return __generator(this, function (_a) {
        switch (_a.label) {
            case 0:
                _a.trys.push([0, 3, , 4]);
                return [4 /*yield*/, ky.post("collections", {
                        json: newCollection,
                        headers: getHeaders(),
                    })];
            case 1:
                response = _a.sent();
                if (!response.ok) {
                    throw new Error("Create error: ".concat(response.statusText));
                }
                return [4 /*yield*/, response.json()];
            case 2:
                data = _a.sent();
                console.log("Collection created successfully");
                return [2 /*return*/, data];
            case 3:
                error_2 = _a.sent();
                console.error("Error creating collection:", error_2);
                throw error_2;
            case 4: return [2 /*return*/];
        }
    });
}); };
/**
 * Prefill data of an edition by its ISSN (DB-787): the ISSN register record when the ISSN is registered
 * (name, qualifier, status, end year, medium; issnRegistered = true), otherwise only the name of a title
 * carrying the ISSN. Null when nothing is found.
 */
export var fetchCollectionByIssn = function (kyInstance, issn) { return __awaiter(void 0, void 0, void 0, function () {
    var normalized, response, data;
    return __generator(this, function (_a) {
        switch (_a.label) {
            case 0:
                normalized = normalizeIssn(issn !== null && issn !== void 0 ? issn : "");
                if (!normalized)
                    return [2 /*return*/, null];
                return [4 /*yield*/, kyInstance.get(collectionsIssnByIssn(encodeURIComponent(normalized)), { headers: getHeaders() })];
            case 1:
                response = _a.sent();
                return [4 /*yield*/, response.json()];
            case 2:
                data = _a.sent();
                return [2 /*return*/, (data === null || data === void 0 ? void 0 : data.issnRegistered) || (data === null || data === void 0 ? void 0 : data.mainName) ? data : null];
        }
    });
}); };
export var fetchCollectionById = function (kyInstance, id) { return __awaiter(void 0, void 0, void 0, function () {
    var res;
    return __generator(this, function (_a) {
        switch (_a.label) {
            case 0: return [4 /*yield*/, kyInstance.get("collections/".concat(encodeURIComponent(id)), {
                    headers: getHeaders(),
                })];
            case 1:
                res = _a.sent();
                if (!res.ok) {
                    throw new Error("Fetch collection by id failed: ".concat(res.status, " ").concat(res.statusText));
                }
                return [2 /*return*/, res.json()];
        }
    });
}); };
